import {EmailPreferences} from './email-preferences';

export class EmailPreferencesMapper {

  public static map(data: any): EmailPreferences {
    const emailPreferences: EmailPreferences = new EmailPreferences();
    emailPreferences.newsletters = !!data.preferences[1];
    emailPreferences.salesAndPromotions = !!data.preferences[3];
    emailPreferences.membersOnlyEmails = !!data.preferences[5];
    emailPreferences.productUpdates = !!data.preferences[7];
    return emailPreferences;
  }

  public static unmap(emailPreferences: any): any {
    const preferences: any[] = [];
    emailPreferences.newsletters && preferences.push(1);
    emailPreferences.salesAndPromotions && preferences.push(3);
    emailPreferences.membersOnlyEmails && preferences.push(5);
    emailPreferences.productUpdates && preferences.push(7);
    return {
      preferences: JSON.stringify(preferences)
    };
  }

}
